import React from 'react'

const Goals = () => {
  return (
    <div className="topmost-goals">
      <h4>Goals</h4>
      <p>
        Planning a coordinated reponse to solve all identifiable problems of Topmost, a set of goals for the project were established along with other stakeholders concerned. It includes;
      </p>
      <ul>
        <li>
          <p>
            Redisigning the websites UI and UX to become user focused
          </p>
        </li>
        <li>
          <p>
            Taking all neccessary measures to eliminate all problems detterring the SEO of the site.
          </p>
        </li>
        <li>
          <p>
            Create a esponsive platform the supports ease of use while performing specific user tasks.
          </p>
        </li>
      </ul>
    </div>
  )
}

export default Goals